const getFactorCompany = params => async (_, __, { api }) => {
  try {
    return api.factorCompany.fetchFactorCompany(params);
  } catch (e) {}
};

export default getFactorCompany;
